import styled from 'styled-components';

const StyledRuleBuilderActionMenu = styled.div`
  margin-left: auto;
  display: flex;

  > * {
    margin-left: ${(props): string => props.theme.spaces.lg};
  }
`;

export default StyledRuleBuilderActionMenu;
